import React, { useState, useEffect } from "react";
import moment from "moment";
import { getClassInstructorList } from "../../actions/instructor";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const InstructorHeaderContent = ({ userName, userId }) => {
  const [currentDateTime, setCurrentDateTime] = useState(moment());
  const [upcomingClassesCount, setUpcomingClassesCount] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setCurrentDateTime(moment()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // Fetch upcoming classes
    const fetchUpcomingClasses = async () => {
      try {
        const response = await getClassInstructorList(userId, {
          orderByValue: "ASC",
          flag: "UPCOMING",
        });
        const classes = response?.data?.responseData?.data || [];
        setUpcomingClassesCount(classes.length);
      } catch (error) {
        console.error("Error fetching classes:", error);
      }
    };

    if (userId) {
      fetchUpcomingClasses();
    }
  }, [userId]);

  const hour = currentDateTime.hour();
  let greeting = "Good Morning";
  if (hour >= 12 && hour < 17) greeting = "Good Afternoon";
  else if (hour >= 17) greeting = "Good Evening";

  return (
    <Link
      to="/dashboard/instructor"
      className="container-fluid py-2 d-flex align-items-center"
      style={{ gap: "14px" }}
    >
      <div>
        <h5
          className="mb-1 fw-semibold text-dark"
          style={{ fontSize: "1.1rem" }}
        >
          {greeting}, {userName}
        </h5>
        {upcomingClassesCount > 0 && (
          <p className="mb-0 text-muted" style={{ fontSize: "0.8rem" }}>
            <span
              className="text-danger fw-medium me-1"
              style={{ marginRight: "4px" }}
            >
              &#x24D8;
            </span>
            You have {upcomingClassesCount} upcoming classes
          </p>
        )}
      </div>

      <div
        className="bg-secondary"
        style={{ width: "2px", height: "20px" }}
      ></div>

      <div>
        <div className="text-muted text-nowrap" style={{ fontSize: "0.75rem" }}>
          {currentDateTime.format("dddd, D MMM")}
        </div>
        <div
          className="fw-semibold text-dark text-nowrap"
          style={{ fontSize: "1.1rem" }}
        >
          {currentDateTime.format("hh:mm A")}
        </div>
      </div>
    </Link>
  );
};

export default InstructorHeaderContent;
